import { AssetsTypes } from '../constants/assetsConstants';

const openWindow = (asset) => ({
    type: AssetsTypes.OPEN_CLOSE_VIEWER,
    opened: true,
    asset,
});

const closeWindow = () => ({
    type: AssetsTypes.OPEN_CLOSE_VIEWER,
    opened: false
});

const updateAsset = (asset) => ({
    type: AssetsTypes.UPDATE_ASSET,
    asset
});

const updateContent = (content) => ({
    type: AssetsTypes.UPDATE_CONTENT,
    content
});

export default {
    openWindow,
    closeWindow,
    updateAsset,
    updateContent
};